import { memo } from 'react';

/**
 * Loading skeleton: three placeholder cards with shimmer.
 *
 * The mobile-app uses RN's `Animated.Value` to drive a 0.3 → 0.7 opacity
 * loop. On the web we get the same look from Tailwind's `animate-pulse`.
 */
function SkeletonCard() {
  return (
    <div className="mx-4 mb-3 overflow-hidden rounded-2xl bg-[#1e1e1e]">
      <div className="h-[200px] w-full animate-pulse bg-[#2a2a2a]" />
      <div className="p-4">
        <div className="mb-2 h-[18px] w-[60px] animate-pulse rounded-[10px] bg-[#2a2a2a]" />
        <div className="mb-1.5 h-[18px] w-[90%] animate-pulse rounded bg-[#2a2a2a]" />
        <div className="mb-2 h-[18px] w-[65%] animate-pulse rounded bg-[#2a2a2a]" />
        <div className="mb-1 h-[14px] w-full animate-pulse rounded bg-[#2a2a2a]" />
        <div className="mb-2.5 h-[14px] w-[75%] animate-pulse rounded bg-[#2a2a2a]" />
        <div className="flex gap-3">
          <div className="h-3 w-10 animate-pulse rounded bg-[#2a2a2a]" />
          <div className="h-3 w-10 animate-pulse rounded bg-[#2a2a2a]" />
          <div className="h-3 w-10 animate-pulse rounded bg-[#2a2a2a]" />
        </div>
      </div>
    </div>
  );
}

export const FeedSkeleton = memo(function FeedSkeleton() {
  return (
    <div className="pt-2">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
});
